/* thepostcard.shop Diwali: finish the rangoli. Tap or Enter lights a dot; arrow keys, Home and End move. */
(() => {
  const COLS = 9;

  function initRangoli(root) {
    root.querySelectorAll('.tps-rangoli__board:not([data-ready])').forEach((board) => {
      board.dataset.ready = '';
      const wrap = board.closest('.tps-rangoli');
      const dots = [...board.querySelectorAll('.tps-rangoli__dot')];
      const out = wrap && wrap.querySelector('[data-rangoli-count]');
      const reset = wrap && wrap.querySelector('[data-rangoli-reset]');
      if (!dots.length) return;

      const isLit = (d) => d.getAttribute('aria-pressed') === 'true';
      const say = (n) => {
        if (!out) return '';
        if (n === 0) return out.dataset.none;
        if (n === dots.length) return out.dataset.all;
        if (n === 1) return out.dataset.one;
        return (out.dataset.many || '').replace('[n]', n);
      };
      const update = () => {
        const n = dots.filter(isLit).length;
        if (out) out.textContent = say(n);
        if (reset) reset.hidden = n === 0;
      };
      const rove = (d) => dots.forEach((x) => { x.tabIndex = x === d ? 0 : -1; });

      board.addEventListener('click', (e) => {
        const d = e.target.closest('.tps-rangoli__dot');
        if (!d) return;
        d.setAttribute('aria-pressed', isLit(d) ? 'false' : 'true');
        rove(d);
        update();
      });

      // Dots carry their row and column; the printed middle has none, so a move steps over it.
      const at = new Map(dots.map((d) => [d.dataset.r + '-' + d.dataset.c, d]));
      const ROWS = Math.max(...dots.map((d) => +d.dataset.r)) + 1;
      const step = (d, dr, dc) => {
        let r = +d.dataset.r + dr;
        let c = +d.dataset.c + dc;
        while (r >= 0 && r < ROWS && c >= 0 && c < COLS) {
          const next = at.get(r + '-' + c);
          if (next) return next;
          r += dr;
          c += dc;
        }
        return d;
      };
      board.addEventListener('keydown', (e) => {
        const d = document.activeElement;
        if (!dots.includes(d)) return;
        let next;
        switch (e.key) {
          case 'ArrowRight': next = step(d, 0, 1); break;
          case 'ArrowLeft': next = step(d, 0, -1); break;
          case 'ArrowDown': next = step(d, 1, 0); break;
          case 'ArrowUp': next = step(d, -1, 0); break;
          case 'Home': next = dots[0]; break;
          case 'End': next = dots[dots.length - 1]; break;
          default: return;
        }
        e.preventDefault();
        rove(next);
        next.focus();
      });

      if (reset) {
        reset.addEventListener('click', () => {
          dots.forEach((d) => d.setAttribute('aria-pressed', 'false'));
          rove(dots[0]);
          update();
          dots[0].focus();
        });
      }

      update();
    });
  }

  const init = (root = document) => initRangoli(root);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
